!function() {

  UC.views.UserDocumentsFilter = Backbone.View.extend({
    initialize: function() {
      new UC.views.UserDocumentsIndex({el: this.$el})
    },
  })
}();
